import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import classes from './loginModal.module.css';
import InputField from "../inputField/inputField";
import SocialLoginButton from "../socialLoginButton/socialLoginButton";
import PromptMessage from "../promptMessage/promptMessage";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";

function LoginModal(props) {
    const navigate = useNavigate();
    const modalRef = useRef(null);
    const [showPrompt, setShowPrompt] = useState(true);

    // Match social login options with main login page
    const socialLoginOptions = [
        { 
            provider: 'google',
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/28bd1d58bec89ad2a3a756cb60ed110fcf90a8ba6843ff87bb59b20414b5b9d0",
            alt: "Google login" 
        },
        { 
            provider: 'facebook',
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/c983773de3122b7a0a4300e505e9c567cd185514936f7f7aa460cd6c8b21f8e5",
            alt: "Facebook login" 
        },
        { 
            provider: 'microsoft',
            icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d6d242305b28473efd487f01949c7703a61fb3baaad156a1da7299b90641eeea",
            alt: "Microsoft login" 
        }
    ];

    const translations = {
        loginToContinue: {
            en: 'Login To Continue',
            ar: 'تسجيل الدخول للمتابعة'
        },
        forgotPassword: {
            en: 'Forgot Password?',
            ar: 'نسيت كلمة المرور؟'
        },
        login: {
            en: 'LOGIN',
            ar: 'تسجيل الدخول'
        },
        loginBy: {
            en: 'Or login by',
            ar: 'أو سجل الدخول عبر'
        },
        noAccount: {
            en: "Don't have an account?",
            ar: 'ليس لديك حساب؟'
        },
        signUp: {
            en: 'Sign up',
            ar: 'تسجيل'
        },
        email: {
            en: 'Email',
            ar: 'البريد الإلكتروني'
        },
        password: {
            en: 'Password',
            ar: 'كلمة المرور'
        },
        enterEmail: {
            en: 'Enter email',
            ar: 'أدخل البريد الإلكتروني'
        },
        enterPassword: {
            en: 'Enter password',
            ar: 'أدخل كلمة المرور'
        }
    };
    const [controls, setControls] = useState({
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterEmail.en : translations.enterEmail.ar,
            },
            value: "",
            label: parseInt(localStorage.getItem('language')) === 1 ? translations.email.en : translations.email.ar,
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        password: {
            elementType: "input",
            elementConfig: {
                type: "password",
                placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterPassword.en : translations.enterPassword.ar,
            },
            value: "",
            validation: {
                required: true,
                minLength: 6,
                maxLength: 32,
            },
            label: parseInt(localStorage.getItem('language')) === 1 ? translations.password.en : translations.password.ar,
            valid: false,
            touched: false
        }
    });
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }
        return isValid;
    })
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value: event.target.value,
                valid: checkValidity(
                    event.target.value,
                    controls[controlName].validation
                ),
                touched: true
            }
        };
        setControls(updatedControls);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                props.setShowLoginForm(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        props.onClearError();
        return () => { props.onClearError(); }
    }, [])
    useEffect(() => {
        props.isAuthenticated && props.currentPath && navigate(props.currentPath);
    }, [props.isAuthenticated])
    const submitHandler = e => {
        setShowPrompt(true);
        e.preventDefault();
        controls.email.value && controls.password.value && props.onAuth(
            controls.email.value,
            controls.password.value
        );
    };
    return (
        <div className={classes.ModalBackdrop}>
            <section className={classes.LoginModal} ref={modalRef}>
                <header className={classes.Header}>
                    <h2 className={classes.Title}>
                        {parseInt(localStorage.getItem('language')) === 1 ? translations.loginToContinue.en : translations.loginToContinue.ar}
                    </h2>
                    <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/cd664c4a2188acf9d24f8ed3c3fec8651d341f35f5b9ab9f47f1ab0324046565"
                        alt="" className={classes.DecorativeIcon} onClick={() => props.setShowLoginForm(false)} />
                </header>
                <form className={classes.LoginForm} onSubmit={(e) => submitHandler(e)}>
                    {form}
                    <a href="/forgot-password" className={classes.ForgotPassword}>
                        {parseInt(localStorage.getItem('language')) === 1 ? translations.forgotPassword.en : translations.forgotPassword.ar}
                    </a>
                    <button type="submit" className={classes.LoginButton}>
                        {parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}
                    </button>
                </form>
                <div className={classes.Divider}>
                    <span className={classes.DividerLine} />
                    <span className={classes.DividerText}>
                        {parseInt(localStorage.getItem('language')) === 1 ? translations.loginBy.en : translations.loginBy.ar}
                    </span>
                    <span className={classes.DividerLine} />
                </div>
                <div className={classes.SocialLoginContainer}>
                    {socialLoginOptions.map((option, index) => (
                        <SocialLoginButton 
                            key={index}
                            provider={option.provider}
                            icon={option.icon}
                            alt={option.alt}
                        />
                    ))}
                </div>
                <p className={classes.SignupPrompt}>
                    {parseInt(localStorage.getItem('language')) === 1 ? translations.noAccount.en : translations.noAccount.ar} 
                    <a href="/register" className={classes.SignupLink}>
                        {parseInt(localStorage.getItem('language')) === 1 ? translations.signUp.en : translations.signUp.ar}
                    </a>
                </p>
            </section>
            {props.error && showPrompt && <PromptMessage message={props.error.message} status='ERROR' button='CLOSE' click={() => setShowPrompt(false)} />}
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password)),
        onSocialAuth: (provider, token) => dispatch(actions.socialAuth(provider, token)),
        onClearError: () => dispatch(actions.clearError()),
    };
};

const mapStateToProps = state => ({
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    token: state.auth.token,
    user: state.auth.user,
    language: state.home.selected_language === 1 ? "en" : "ar",
    success_message: state.auth.success_message,
    email: state.profile.userProfile.email,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);